<template>

    <div class="container-fluid" style="padding: 25px; background-color: wheat">

        <div class="col-sm-10">
            <p>Select Animal Image ({{ uploadingLabel }})</p>
            <image-upload
                :target="getImageUploadUrl"
                selector="example"
                :auto-push="true">
            </image-upload>
            <br/>
        </div>

        <fieldset>
            <div class="form-group">
                <div class="col-sm-12 col-md-6">
                    <label @click="modifyUrl=!modifyUrl">{{ uploadURL }} (Change
                        URL)</label>
                    <fg-input
                        v-if="modifyUrl"
                        type="text"
                        label="Image URL"
                        name="Image URL"
                        v-model="uploadURL">
                    </fg-input>
                </div>
            </div>
            <br/>

        </fieldset>

        <fieldset>
            <div class="form-group">
                <div class="col-sm-12 col-md-4">
                    <label>Caught Date & Time</label>
                    <fg-input
                        type="datetime-local"
                        name="Caught Date"
                        v-model="record.caughtDate">
                    </fg-input>
                </div>
                <div class="col-sm-12 col-md-4">
                    <label class="control-label">Species</label>
                    <div>
                        <el-radio-group v-model="record.species">
                            <el-radio-button
                                v-for="species in speciesList"
                                :key="species.id"
                                :label="species.species_name">
                                {{ species.species_name }}
                            </el-radio-button>
                        </el-radio-group>
                    </div>
                </div>
                <div class="col-sm-12 col-md-4">
                    <label class="control-label">Gender</label>
                    <div>
                        <el-radio-group v-model="record.gender">
                            <el-radio-button label="Male" key="1"></el-radio-button>
                            <el-radio-button label="Female" key="0"></el-radio-button>
                        </el-radio-group>
                    </div>
                </div>
            </div>
            <br/>

        </fieldset>

        <fieldset>
            <div class="form-group">
                <label class="col-sm-12 control-label">Caught Method</label>
                <div class="col-sm-12">
                    <el-radio-group v-model="record.caughtMethod">
                        <el-radio-button label="Owner Handover" key="Owner Handover">Owner Handover</el-radio-button>
                        <el-radio-button label="Community Handover" key="Community Handover">Community Handover</el-radio-button>
                        <el-radio-button label="Hand" key="Hand">Hand</el-radio-button>
                        <el-radio-button label="Net" key="Net">Net</el-radio-button>
                        <el-radio-button label="Scruff" key="Scruff">Scruff</el-radio-button>
                        <el-radio-button label="Trap" key="Trap">Trap</el-radio-button>
                    </el-radio-group>
                </div>
            </div>
        </fieldset>

        <fieldset>
            <div class="form-group">
                <label class="col-sm-12 control-label">Animal Color</label>
                <div class="col-sm-12">
                    <el-select v-model="record.animalColor" placeholder="Select color">
                        <el-option
                            v-for="color in animalColors"
                            :key="color"
                            :label="color"
                            :value="color">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </fieldset>

        <br/>

        <fieldset>
            <div class="form-group">
                <div class="col-sm-12 col-md-6">
                    <fg-input
                        type="text"
                        label="Animal Name"
                        name="Animal Name"
                        v-model="record.animalName">
                    </fg-input>
                </div>
                <div class="col-sm-12 col-md-6">
                    <fg-input
                        type="text"
                        label="Collar ID"
                        name="Collar ID"
                        v-model="record.collarId">
                    </fg-input>
                </div>
            </div>
            <br/>

        </fieldset>

        <fieldset>
            <div class="form-group">
                <div class="col-sm-12 col-md-6">
                    <fg-input
                        type="text"
                        label="RFID"
                        name="RFID"
                        v-model="record.rfid">
                    </fg-input>
                </div>
                <div class="col-sm-12 col-md-6">
                    <fg-input
                        type="text"
                        label="RFID Location"
                        name="RFID Location"
                        v-model="record.rfidLocation">
                    </fg-input>
                </div>
            </div>
            <br/>

        </fieldset>

        <fieldset>
            <div class="form-group">
                <div class="col-sm-12">
                    <label class="control-label">Caught Location</label>
                    <p class="text-muted small">Search for location and click on the map to pin the exact catch location</p>
                    <div class="card">
                        <div class="card-body">
                            <MapBase
                                v-if="mapCenter.lat"
                                :allowPinDrop="true"
                                :enableSearch="true"
                                :zoom="15"
                                :center="mapCenter"
                                :height="'400px'"
                                @map-clicked="handleMapClick"
                                @address-selected="handleAddressSelected"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-12 col-md-6">
                    <fg-input
                        type="text"
                        label="Latitude"
                        name="Latitude"
                        :disabled="true"
                        v-model="record.caughtLatitude">
                    </fg-input>
                </div>
                <div class="col-sm-12 col-md-6">
                    <fg-input
                        type="text"
                        label="Longitude"
                        name="Longitude"
                        :disabled="true"
                        v-model="record.caughtLongitude">
                    </fg-input>
                </div>
            </div>
            <div class="form-group">
                <div class="col-sm-12">
                    <fg-input
                        type="text"
                        label="Landmark (Optional)"
                        name="Landmark"
                        v-model="record.landmark">
                    </fg-input>
                </div>
            </div>
            <br/>

        </fieldset>

        <fieldset>
            <br/>

            <div class="form-group">
                <label class="col-sm-12 control-label">Age Category</label>
                <div class="col-sm-12">
                    <el-radio-group v-model="record.ageCategory">
                        <el-radio-button label="Lactating" key="Lactating">Lactating</el-radio-button>
                        <el-radio-button label="Pregnant" key="Pregnant">Pregnant</el-radio-button>
                        <el-radio-button label="Senior" key="Senior">Senior</el-radio-button>
                        <el-radio-button label="Adult" key="Adult">Adult</el-radio-button>
                        <el-radio-button label="Young" key="Young">Young</el-radio-button>
                    </el-radio-group>
                </div>
            </div>
        </fieldset>

        <br/>

        <fieldset>
            <div class="form-group">
                <div class="col-sm-12 col-md-6">
                    <label class="control-label">Age - Years</label>
                    <el-select v-model="record.ageYears" placeholder="Select years">
                        <el-option
                            v-for="year in ageYearOptions"
                            :key="year"
                            :label="year"
                            :value="year">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-sm-12 col-md-6">
                    <label class="control-label">Age - Months</label>
                    <el-select v-model="record.ageMonths" placeholder="Select months">
                        <el-option
                            v-for="month in ageMonthOptions"
                            :key="month"
                            :label="month"
                            :value="month">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <br/>

        </fieldset>

        <br/>


        <fieldset>
            <div class="form-group">
                <label class="col-sm-12 control-label">Ownership</label>
                <div class="col-sm-12">
                    <el-radio-group v-model="record.ownership">
                        <el-radio-button
                            v-for="(ownership, index) in ownershipOptions"
                            :key="'ownership-' + index"
                            :label="ownership">
                            {{ ownership }}
                        </el-radio-button>
                    </el-radio-group>
                </div>
            </div>
        </fieldset>

        <br>

        <!-- Owner Information Section - Conditional -->
        <fieldset v-if="showOwnerSection">
            <legend class="col-sm-12"><strong>Owner Information</strong></legend>

            <div class="form-group">
                <div class="col-sm-12 col-md-6">
                    <fg-input
                        type="text"
                        label="Owner Name"
                        name="Owner Name"
                        v-model="record.ownerName">
                    </fg-input>
                </div>
                <div class="col-sm-12 col-md-6">
                    <fg-input
                        type="tel"
                        label="Mobile Number"
                        name="Mobile Number"
                        v-model="record.telephoneMobile">
                    </fg-input>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12 col-md-12">
                    <fg-input
                        type="text"
                        label="Owner Address"
                        name="Owner Address"
                        placeholder="Enter owner's address manually"
                        v-model="record.ownerAddress">
                    </fg-input>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12">
                    <label class="control-label">Owner Location</label>
                    <p class="text-muted small">Search for location and click on the map to pin the owner's location</p>
                    <div class="card">
                        <div class="card-body">
                            <MapBase
                                v-if="ownerMapCenter.lat"
                                :allowPinDrop="true"
                                :enableSearch="true"
                                :zoom="15"
                                :center="ownerMapCenter"
                                :height="'400px'"
                                @map-clicked="handleOwnerMapClick"
                                @address-selected="handleOwnerAddressSelected"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12 col-md-6">
                    <fg-input
                        type="text"
                        label="Latitude"
                        name="Owner Latitude"
                        :disabled="true"
                        v-model="record.ownerLocationLatitude">
                    </fg-input>
                </div>
                <div class="col-sm-12 col-md-6">
                    <fg-input
                        type="text"
                        label="Longitude"
                        name="Owner Longitude"
                        :disabled="true"
                        v-model="record.ownerLocationLongitude">
                    </fg-input>
                </div>
            </div>
            <br/>
        </fieldset>

        <fieldset>
            <div class="form-group">
                <label class="col-sm-12 control-label">Notes</label>
                <div class="col-sm-12">
                     <textarea v-model="record.notes" class="form-control"
                               rows="3" placeholder="Additional notes about the catch..."></textarea>
                </div>
            </div>
        </fieldset>


        <br>


        <div class="col-md-12">

            <button :disabled="isCallingApi" v-on:click="saveCatchingData" type="button"
                    class="btn btn-round btn-info">SAVE CATCHING RECORD
            </button>

        </div>
    </div>

</template>

<script>

import mixin from '../../../mixins/GlobalMixin';

import ImageUpload from "../../ImageUpload";
import MapBase from '../../map/MapBase.vue';
import ReverseGeocodingService from '../../../services/reverse-geocoding.service';

import {Select, Option, CheckboxGroup, Checkbox, RadioGroup, RadioButton} from 'element-ui';


export default {
    name: 'AddPopulationManagementData',
    components: {
        [Option.name]: Option,
        [Select.name]: Select,
        [CheckboxGroup.name]: CheckboxGroup,
        [RadioGroup.name]: RadioGroup,
        [Checkbox.name]: Checkbox,
        [RadioButton.name]: RadioButton,
        'image-upload': ImageUpload,
        MapBase,
    },
    mixins: [mixin],
    props: {
        areaId: {
            type: String,
            default: "0",
        },
        projectId: {
            type: String,
            default: "0",
        },
    },
    data() {
        return {

            record: {
                // Animal Record fields
                animalName: '',
                rfid: '',
                rfidLocation: '',
                species: '',
                gender: '',
                animalColor: '',

                // Catch Release Record fields
                caughtLocation: '',
                caughtLatitude: '',
                caughtLongitude: '',
                caughtDate: '',
                caughtMethod: '',
                ageCategory: '',
                ageYears: '0 Year',
                ageMonths: '0 Month',
                ownership: '',
                collarId: '',
                landmark: '',
                notes: '',

                // Owner fields (conditional)
                ownerName: '',
                telephoneMobile: '',
                ownerAddress: '',
                ownerLocationLatitude: '',
                ownerLocationLongitude: ''
            },

            imageUploadApiUrl: window.API_BASE_URL + '/UploadToS3/slim/upload/animal/picture/for/project',

            ownershipOptions: [],

            animalColors: [
                'Black',
                'Black/tan',
                'Black/white',
                'Brindle',
                'Brown',
                'Brown/white',
                'Sable',
                'White',
                'White mix',
                'Tri Colour',
                'Ginger',
                'Tortious Shell',
                'Gray'
            ],

            ageYearOptions: [
                '0 Year', '1 Year', '2 Year', '3 Year', '4 Year', '5 Year',
                '6 Year', '7 Year', '8 Year', '9 Year', '10 Year', '11 Year',
                '12 Year', '13 Year', '14 Year', '15 Year', '16 Year', '17 Year',
                '18 Year', '19 Year', '20 Year'
            ],

            ageMonthOptions: [
                '0 Month', '1 Month', '2 Month', '3 Month', '4 Month', '5 Month',
                '6 Month', '7 Month', '8 Month', '9 Month', '10 Month', '11 Month'
            ],

            uploadURL: '',
            uploadingLabel: 'Animal Image',
            uploadPending: false,

            modifyUrl: false,

            isCallingApi: false,

            speciesList: [],
            project: null,

            mapCenter: {},
            ownerMapCenter: {}

        }
    },

    methods: {
        async init() {

            let vm = this;

            // Load project details and species from project - same logic as ProjectSettings
            vm.project = vm.$store.getters.getCurrentSelectedProject;
            console.log('Current project:', vm.project);

            if (vm.project) {
                // Get species from cached project first
                if (vm.project.project_animals && vm.project.project_animals.length > 0) {
                    vm.speciesList = vm.project.project_animals.map(pa => pa.animal);
                    console.log('Loaded species from project.project_animals:', vm.speciesList);
                }

                // ALWAYS fetch project details from API to get ownership configuration
                // (ownership is not included in the cached project object)
                try {
                    console.log('Fetching project details from API with project_id:', vm.$props.projectId);
                    const response = await axios.get('/project/details', {
                        params: {
                            project_id: vm.$props.projectId
                        }
                    });
                    const projectData = response.data.response.data.project;
                    console.log('Project data from API:', projectData);
                    console.log('API Project data keys:', Object.keys(projectData));

                    // Load species from API if not already loaded
                    if (vm.speciesList.length === 0 && projectData.project_animals && projectData.project_animals.length > 0) {
                        vm.speciesList = projectData.project_animals.map(pa => pa.animal);
                        console.log('Loaded species from API project.project_animals:', vm.speciesList);
                    }

                    // Load ownership options from API - try all possible property variations
                    if (projectData.project_ownerships && projectData.project_ownerships.length > 0) {
                        vm.ownershipOptions = projectData.project_ownerships.map(po => po.ownership || po.ownership_type || po.name || po.type);
                        console.log('✓ Loaded ownership from API project.project_ownerships:', vm.ownershipOptions);
                    } else if (projectData.ownership && Array.isArray(projectData.ownership)) {
                        vm.ownershipOptions = projectData.ownership;
                        console.log('✓ Loaded ownership from API project.ownership (array):', vm.ownershipOptions);
                    } else if (projectData.ownerships && Array.isArray(projectData.ownerships)) {
                        vm.ownershipOptions = projectData.ownerships;
                        console.log('✓ Loaded ownership from API project.ownerships:', vm.ownershipOptions);
                    } else if (projectData.ownership_types && Array.isArray(projectData.ownership_types)) {
                        vm.ownershipOptions = projectData.ownership_types;
                        console.log('✓ Loaded ownership from API project.ownership_types:', vm.ownershipOptions);
                    } else if (typeof projectData.ownership === 'string' && projectData.ownership.length > 0) {
                        // Might be stored as comma-separated string
                        vm.ownershipOptions = projectData.ownership.split(',').map(o => o.trim());
                        console.log('✓ Loaded ownership from API project.ownership (string split):', vm.ownershipOptions);
                    } else {
                        console.warn('⚠ No ownership config found in API response');
                        console.warn('Available keys in projectData:', Object.keys(projectData));
                    }
                } catch (error) {
                    console.error('Error loading project details from API:', error);
                }

                // Fallback to default ownerships if none found
                if (!vm.ownershipOptions || vm.ownershipOptions.length === 0) {
                    vm.ownershipOptions = [
                        "Owned",
                        "Owned free roaming",
                        "Community",
                        "Community free roaming",
                        "Stray",
                        "Wild"
                    ];
                    console.log('Using default ownership options:', vm.ownershipOptions);
                }

                console.log('Final speciesList:', vm.speciesList);
                console.log('Final ownershipOptions:', vm.ownershipOptions);

                // Set default species if only one exists
                if (vm.speciesList && vm.speciesList.length === 1) {
                    vm.record.species = vm.speciesList[0].species_name;
                    console.log('Auto-selected species:', vm.record.species);
                }
            }

            Bus.$on('example-did-upload', (error, data, response) => {
                if (error) {
                    toastr.error(error);
                } else {
                    // Encode the URL to handle spaces and special characters
                    vm.uploadURL = encodeURI(response.src);
                    vm.uploadingLabel = "Uploaded";
                    vm.uploadPending = false;
                }
            });

            Bus.$on('example-is-saving', () => {
                vm.uploadPending = true;
                vm.uploadingLabel = "Uploading Image...";
            });

            // Initialize map center
            vm.initMap();

        },

        initMap() {
            let vm = this;

            // Try to get user's current location
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        const center = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        vm.mapCenter = center;
                        vm.ownerMapCenter = center;
                    },
                    function (error) {
                        console.log('Geolocation error:', error);
                        // Fallback to default location (e.g., center of country)
                        const defaultCenter = { lat: 23.03, lng: 72.58 };
                        vm.mapCenter = defaultCenter;
                        vm.ownerMapCenter = defaultCenter;
                    }
                );
            } else {
                // Browser doesn't support Geolocation
                console.log('Browser does not support geolocation');
                const defaultCenter = { lat: 23.03, lng: 72.58 };
                vm.mapCenter = defaultCenter;
                vm.ownerMapCenter = defaultCenter;
            }
        },

        async handleMapClick(latLng) {
            let vm = this;

            // Update the caught location coordinates
            vm.record.caughtLatitude = latLng.lat.toFixed(6);
            vm.record.caughtLongitude = latLng.lng.toFixed(6);
            vm.record.caughtLocation = `${vm.record.caughtLatitude},${vm.record.caughtLongitude}`;

            console.log('Map clicked at:', latLng);
        },

        handleAddressSelected(location) {
            let vm = this;

            // When user searches for an address, update coordinates
            const latLng = {
                lat: location.y,
                lng: location.x
            };

            vm.handleMapClick(latLng);
        },

        async handleOwnerMapClick(latLng) {
            let vm = this;

            // Update the owner location coordinates
            vm.record.ownerLocationLatitude = latLng.lat.toFixed(6);
            vm.record.ownerLocationLongitude = latLng.lng.toFixed(6);

            console.log('Owner location map clicked at:', latLng);
        },

        handleOwnerAddressSelected(location) {
            let vm = this;

            // When user searches for an address for owner, update coordinates
            const latLng = {
                lat: location.y,
                lng: location.x
            };

            vm.handleOwnerMapClick(latLng);
        },

        saveCatchingData() {

            const vm = this

            // Validation
            if (vm.uploadURL === '') {
                alert("Please select and upload animal image")
                return
            }

            if (!vm.record.species) {
                alert("Please select a species")
                return
            }

            if (!vm.record.caughtDate) {
                alert("Please enter caught date")
                return
            }

            if (!vm.record.caughtMethod) {
                alert("Please select caught method")
                return
            }

            vm.isCallingApi = true

            // Get location and then upload
            if (vm.record.caughtLocation !== "") {
                vm.uploadData()
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        vm.record.caughtLocation = position.coords.latitude + ',' + position.coords.longitude
                        vm.uploadData()
                    }, function () {
                        alert('Please allow location access to save this record')
                        vm.isCallingApi = false
                    });
                } else {
                    alert('ERROR: Please allow location permission access')
                    vm.isCallingApi = false
                }
            }

        },

        formatAge(years, months) {
            // Concatenate year and month as string (e.g., "1 Year 6 Month")
            return `${years} ${months}`;
        },

        formatDateTimeForMySQL(dateTimeString) {
            // Convert datetime-local format to MySQL datetime format (YYYY-MM-DD HH:MM:SS)
            if (!dateTimeString) return '';

            const date = new Date(dateTimeString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

        uploadData() {

            const vm = this

            // Prepare payload matching PHP backend expectations
            const payload = {
                // Required
                project_id: vm.$props.projectId,

                // Animal Record fields
                species: vm.record.species,
                image_url: vm.uploadURL,
                gender: vm.record.gender,
                rf_id: vm.record.rfid || null,
                animal_color: vm.record.animalColor,
                rf_id_location: vm.record.rfidLocation,
                breed: '',
                animal_name: vm.record.animalName,

                // Catch Release Record fields
                area_id: vm.$props.areaId,
                caught_location: vm.record.caughtLocation,
                caught_date: vm.formatDateTimeForMySQL(vm.record.caughtDate),
                caught_method: vm.record.caughtMethod,
                ownership: vm.record.ownership,
                age_category: vm.record.ageCategory,
                age: vm.formatAge(vm.record.ageYears, vm.record.ageMonths),
                behaviour: '',
                condition: '',
                outside_the_area: 0,
                note: vm.record.notes,
                collar_id: vm.record.collarId,
                landmark: vm.record.landmark,
            }

            // Add owner information if applicable
            if (vm.showOwnerSection && vm.record.ownerName) {
                payload.owner_name = vm.record.ownerName
                payload.telephone_mobile = vm.record.telephoneMobile
                payload.email_address = ''
                payload.admin_area_level1 = ''
                payload.owner_address = vm.record.ownerAddress
                payload.owner_locality = ''
                payload.owner_location_latitude = vm.record.ownerLocationLatitude
                payload.owner_location_longitude = vm.record.ownerLocationLongitude
                payload.google_postal_code = ''
                payload.details = ''
            }

            window.axios.post('/catch_release/catching/add', payload)
                .then(response => {
                    console.log(response)
                    vm.isCallingApi = false

                    if (response.data.response.error.error_code === 0) {
                        vm.showAlert("Success", "Catching Record Added Successfully", true, null)
                        
                        // Reload the page to clear the form
                        setTimeout(() => {
                            window.location.reload()
                        }, 1500)
                    } else {
                        vm.showAlert("Error", response.data.response.error.error_message || "Failed to save record", false, null)
                    }
                })
                .catch(error => {
                    vm.isCallingApi = false
                    console.error(error)
                    const errorMessage = (error.response && error.response.data && error.response.data.message) || "An error occurred while saving the record"
                    vm.showAlert("Error", errorMessage, false, null)
                })

        }

    },

    mounted() {
        this.init();
    },

    computed: {

        getImageUploadUrl() {
            return this.imageUploadApiUrl + '/' + this.$props.projectId
        },

        showOwnerSection() {
            return this.record.ownership === 'Owned' ||
                   this.record.ownership === 'Owned free roaming' ||
                   this.record.ownership === 'Community'
        }

    },

    beforeRouteLeave(to, from, next) {
        // If the form is dirty and the user did not confirm leave,
        // prevent losing unsaved changes by canceling navigation
        const leaveConfirm = window.confirm(
            "Are you sure you want to leave? any unsaved changes will be lost"
        );
        if (leaveConfirm) {
            next();
        } else {
            // Navigate to next view
            next(false);
        }
    },


}

</script>
<style scoped>

#description {
    font-family: "Noto Sans";
    font-size: 15px;
    font-weight: 300;
}

#infowindow-content .title {
    font-weight: bold;
}

#infowindow-content {
    display: none;
}

#map #infowindow-content {
    display: inline;
}

.pac-card {
    margin: 10px 10px 0 0;
    border-radius: 2px 0 0 2px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    outline: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    background-color: #fff;
    font-family: "Noto Sans";
    width: 100%;
    max-width: 424px;
}

.pac-card #pac-input {
    width: 100%;
    max-width: 400px;
}

#pac-container {
    padding-bottom: 12px;
    margin-right: 12px;
}

.pac-controls {
    display: inline-block;
    padding: 5px 11px;
}

.pac-controls label {
    font-family: "Noto Sans";
    font-size: 13px;
    font-weight: 300;
}

#pac-input {
    background-color: #fff;
    font-family: "Noto Sans";
    font-size: 15px;
    font-weight: 300;
    margin-left: 12px;
    padding: 0 11px 0 13px;
    text-overflow: ellipsis;
    width: 400px;
}

#pac-input:focus {
    border-color: #4d90fe;
}

#title {
    color: #fff;
    background-color: #4d90fe;
    font-size: 25px;
    font-weight: 500;
    padding: 6px 12px;
}

a {
    color: #51cbce;
}

a:hover {
    cursor: pointer;
    text-decoration: underline;
    color: #51cbce;
}

.checkbox_lbl {
    margin-right: 20px;
    display: inline-block;
    vertical-align: middle;
    position: relative;
    margin-top: -14px;
}

.hideMvOptions {
    display: none;
}

.logo_img {
    height: 30px;
    border-radius: 0px !important;
}

.hideMvOptions {
    display: none;
}

.logo_img {
    height: 30px;
    border-radius: 0px !important;
}

/* Pradeep Start */
.set_msg {
    margin-top: 5%;
}

.help-icon {
    cursor: pointer;
    position: absolute;
    margin-left: 5px;
    margin-top: -15px;
    color: #51cbce !important;;
}

@media (max-width: 320px) {
    .set_msg {
        margin-top: 15% !important;
    }
}

@media (min-width: 321px) and (max-width: 374px) {
    .set_msg {
        margin-top: 15% !important;
    }
}

@media (min-width: 375px) and (max-width: 424px) {
    .set_msg {
        margin-top: 15% !important;
    }
}

@media (min-width: 425px) and (max-width: 767px) {
    .set_msg {
        margin-top: 15% !important;
    }
}

@media (min-width: 768px) and (max-width: 769px) {
    .set_msg {
        margin-top: 5% !important;

    }
}

.el-checkbox {
    margin: 0;
    padding: 0px 20px 5px 0px;
}

.el-select {
    width: inherit;
}

/* Pradeep End */
</style>
